import { Component, Vue } from 'vue-property-decorator';
import { EColorState } from "@/components/IBPayment/interface";

@Component
export default class IBPaymentCardButtonColor extends Vue {

	buttonClassNameByColor: any = {
		[EColorState.primary]: 'btn-primary',
		[EColorState.light]: 'btn-light',
		[EColorState.danger]: 'btn-danger',
		[EColorState.danger_outlined]: 'btn-danger_outlined',
		[EColorState.secondary]: 'secondary',
		[EColorState.info]: 'btn-info',
		[EColorState.primary_second]: 'btn-primary_second'
	}

	getButtonClassNameByColor(v?: EColorState): string {
		return (v && this.buttonClassNameByColor[v]) || '';
	}

}
